module.exports = "/assets/f90dbca4b1213bb6e994447a4649eec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VW.png
// module id = 3060
// module chunks = 0